import {
  ERROR_NAME_NETWORK
} from '@/constants/settings'
import { PARTICIPANT_TYPES, MAIN_ADMIN_NAME } from '@/constants/business'
import { mapActions, mapState } from 'vuex'
import { CURRENT_USER, ACCOUNT } from '@/constants/store.js'

const currentUserMixin = {
  computed: {
    ...mapState(ACCOUNT.NAMESPACE, {
      isLoggedIn: ACCOUNT.STATE.IS_LOGGED_IN,
      token: ACCOUNT.STATE.TOKEN,
      participantType: ACCOUNT.STATE.PARTICIPANT_TYPE,
      currentUserName: state => (state[ACCOUNT.STATE.USER_NAME]?.toUpperCase() || '')
    }),
    ...mapState(CURRENT_USER.NAMESPACE, {
      currentUserId: CURRENT_USER.STATE.USER_ID,
      currentUserOrganizationId: CURRENT_USER.STATE.ORGANIZATION_ID
    }),
    isMainAdmin () {
      return this.currentUserName === MAIN_ADMIN_NAME
    },
    isAdmin () {
      return this.participantType === PARTICIPANT_TYPES.SUPER_ORGANIZER
    },
    isRegistered () {
      return !!this.participantType
    },
    isOrganizer () {
      return this.participantType === PARTICIPANT_TYPES.ORGANIZER
    },
    isParticipant () {
      return this.participantType === PARTICIPANT_TYPES.PARTICIPANT
    },
    isLotOwner () {
      return (lot) => {
        return !!this.currentUserId && lot.creatorId === this.currentUserId
      }
    }
  },
  methods: {
    ...mapActions(CURRENT_USER.NAMESPACE, {
      getCurrentUserInfoAction: CURRENT_USER.ACTIONS.GET_CURRENT_USER_INFO
    }),
    ...mapActions(ACCOUNT.NAMESPACE, {
      exitAction: ACCOUNT.ACTIONS.LOG_OUT
    }),
    getCurrentUserInfo: async function () {
      // проверка доступа на случай, если сохранен токен, но учетные данные поменялись или пользователь заблокирован
      try {
        await this.getCurrentUserInfoAction()
      } catch (error) {
        if (error &&
          error.name !== ERROR_NAME_NETWORK) {
          await this.exitAction()
        }

        this.throwIfNotServerError(error)
        this.goToRoute(`${this.urlRootPath}/login`)
      }
    },
    logOut: async function () {
      await this.exitAction()
      this.goToRoute(`${this.urlRootPath}/`)
    }
  }
}

export default currentUserMixin
